<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-building"></i> {{ "TITLE.ENTERPRISE" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="enterpriseForm">
      <div class="form-row mb-0">
        <div class="form-group col-md-5 mb-0" *ngIf="hasRole(ROLE_SUPERADMIN)">
          <label for="partnerCheckbox">{{ "LABEL.IS-PARTNER" | translate }}</label>
          <div class="custom-control custom-checkbox my-1 mr-sm-2">
            <input type="checkbox"
                   class="custom-control-input"
                   id="partnerCheckbox"
                   formControlName="isPartner"
                   [(ngModel)]="enterprise.isPartner"
                   (change)="changePartner($event)">
            <label class="custom-control-label" for="partnerCheckbox">{{ "LABEL.YES" | translate }}</label>
          </div>
        </div>
      </div>
      <label *ngIf="hasRole(ROLE_SUPERADMIN) && !createPartner">{{ "LABEL.PARTNER" | translate }}</label>
      <div class="input-group" *ngIf="hasRole(ROLE_SUPERADMIN) && !createPartner">
        <div class="input-group-prepend">
          <div class="input-group-text">
            <i class="fa fa-university"></i>
          </div>
        </div>
        <select class="form-control ml-1 custom-width-select"
                [(ngModel)]="enterprise.partnerId"
                formControlName="partner">
          <option *ngFor="let partner of partners" [ngValue]="partner.id">{{partner.name | translate}}</option>
        </select>
      </div>

      <div class="form-row">
        <div class="form-group col-md-5">
          <label for="docTypeInput">{{ "LABEL.DOCUMENT-TYPE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fa">T.</i>
              </div>
            </div>
            <select id="docTypeInput"
                    class="form-control"
                    [(ngModel)]="enterprise.documentType"
                    formControlName="docType"
                    [class.is-invalid]="isInvalidControl('docType')"
                    [attr.disabled]="!isNewEnterprise?'': null">
              <option>{{ "MESSAGE.SELECT" | translate }}</option>
              <option selected [value]="6">RUC</option>
            </select>
          </div>
          <small *ngIf="isInvalidControl('docType')"
                 class="text-danger">
            {{ "MESSAGE.SELECT-DOCUMENT-TYPE" | translate }}
          </small>
        </div>
        <div class="form-group col-md-7">
          <label for="DocNumberInput">{{ "LABEL.DOCUMENT-NUMBER" | translate }} <small [ngbTooltip]="tipRequired"
                                                                                       class="font-weight-bold text-danger">(*)</small></label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fa fa-number">N.</i>
              </div>
            </div>
            <input type="text"
                   id="DocNumberInput"
                   class="form-control"
                   [(ngModel)]="enterprise.documentNumber"
                   formControlName="docNumber"
                   [class.is-invalid]="isInvalidControl('docNumber')">
            <div class="input-group-prepend">
              <button class="btn btn-outline-success b-radius"
                      [disabled]="!enableBtnSearch" [ngbTooltip]="viewBtnInfo"
                      (click)="getBy(enterprise.documentNumber)">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
          <small *ngIf="isInvalidControl('docNumber')"
                 class="text-danger">
            {{ "MESSAGE.ENTER-NUMBER-11-DIGITS" | translate }}
          </small>
        </div>
      </div>
      <div class="form-group">
        <label for="nameInput">{{ "LABEL.ENTERPRISE-NAME" | translate }}
          <small [ngbTooltip]="tipRequired" class="font-weight-bold text-danger">(*)</small></label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i class="fa fa-keyboard"></i>
            </div>
          </div>
          <input type="text"
                 id="nameInput"
                 class="form-control"
                 placeholder="IOFE S.A.C."
                 [(ngModel)]="enterprise.name"
                 formControlName="name"
                 [class.is-invalid]="isInvalidControl('name')">
        </div>
        <small *ngIf="isInvalidControl('name')"
               class="text-danger">
          {{ "MESSAGE.ENTER-ENTERPRISE-NAME" | translate }}
        </small>
      </div>
      <div class="form-group">
        <label for="comercialName">{{ "LABEL.COMMERCIAL-NAME" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i class="fa fa-keyboard"></i>
            </div>
          </div>
          <input type="text"
                 id="comercialName"
                 class="form-control"
                 placeholder="Main St"
                 [(ngModel)]="enterprise.tradeName"
                 formControlName="tradeName"
                 [class.is-invalid]="isInvalidControl('tradeName')">
        </div>
        <small *ngIf="isInvalidControl('tradeName')"
               class="text-danger">
          {{ "MESSAGE.ENTER-COMMERCIAL-NAME" | translate }}
        </small>
      </div>
      <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN)">
        <label for="emailAddress">{{ "LABEL.E-MAIL" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i class="fa fa-envelope" aria-hidden="true"></i>
            </div>
          </div>
          <input type="text"
                 id="emailAddress"
                 class="form-control"
                 placeholder="Ejem. no-reply@iofesign.com"
                 [(ngModel)]="enterprise.email"
                 formControlName="email"
                 [class.is-invalid]="isInvalidControl('email')">
        </div>
        <small *ngIf="isInvalidControl('email')"
               class="text-danger">
          {{ "MESSAGE.ENTER-VALID-EMAIL" | translate }}
        </small>
      </div>
      <div class="row form-group">
        <div class="col">
          <label for="storageLimit">Límite de almacenamiento</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fa fa-hdd" aria-hidden="true"></i>
              </div>
            </div>
            <input type="text"
                   id="storageLimit"
                   class="form-control"
                   placeholder="Ejem. 500 "
                   [(ngModel)]="limitStorage"
                   formControlName="limitStorage"
                   [class.is-invalid]="isInvalidControl('limitStorage')">
          </div>
          <small *ngIf="isInvalidControl('limitStorage')"
                 class="text-danger">
            Ingrese el limite de almacenamiento.
          </small>
        </div>
        <div class="col-md-4">
          <label>Tipo de unidad</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fa fa-disk">T.</i>
              </div>
            </div>
            <select class="form-control"
                    formControlName="storageType"
                    [(ngModel)]="storageType">
              <option *ngFor="let storageType of storageTypes"
                      [value]="storageType.id">
                {{storageType.name}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="form-group" *ngIf="hasAuthority('own:view:enterprise:10200')">
        <label for="maxWorkflows">{{ "LABEL.QUANTITY-FLOWS-ALLOWED" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i class="fas fa-sort-numeric-up"></i>
            </div>
          </div>
          <input type="text"
                 id="maxWorkflows"
                 class="form-control"
                 placeholder="{{ 'MESSAGE.MAXIMUM-QUANTITY-ALLOWED' | translate }}"
                 [(ngModel)]="enterprise.maxWorkflows"
                 formControlName="maxWorkflows">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col">
          <label>Logo</label>
          <div class="custom-file content-file">
            <input type="file"
                   [disabled]="false"
                   class="custom-file-input"
                   accept="image/jpeg, image/png"
                   alife-file-to-base64
                   id="enterpriseLogoFile"
                   (change)="readSelectedLogo($event)"
                   (onFileChanged)="changeStatus($event)">
            <div class="custom-file-label">
              <label for="enterpriseLogoFile">
                {{enterpriseForm.get('logoFilename2Show').value ? enterpriseForm.get('logoFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row text-right">
        <img class="center" [src]="defaultLogoSrc" #rubricPic style="{{styleDimensionsLogo}}" alt="Rubric">
      </div>
      <div class="form-group mt-4">
        <div class="alert badge-dark alert-dismissible pr-5 pt-1 pb-1" role="alert">
          <div [innerHTML]="'MESSAGE.RECOMMENDED-UPLOAD-LOGO-TRANSPARENT-BACKGROUND'| translate "></div>
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="form-row mt-4">
        <div class="form-group col-md-7" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
          <label for="customerCheckbox">{{ "LABEL.IS-A-CUSTOMER" | translate }}</label>
          <div class="custom-control custom-checkbox my-1 mr-sm-2">
            <input type="checkbox"
                   class="custom-control-input"
                   id="customerCheckbox"
                   formControlName="isCustomer"
                   [(ngModel)]="enterprise.isCustomer"
                   (change)="changeCustomer($event)">
            <label class="custom-control-label" for="customerCheckbox">{{ "LABEL.YES" | translate }}</label>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger"
            (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
<ng-template #tipRequired>{{ "MESSAGE.FIELD-REQUIRED" | translate }}</ng-template>
<ng-template #viewBtnInfo>{{ "MESSAGE.SEARCH-ENTERPRISE-DATA-SUNAT"  | translate }}</ng-template>
